import { MobileAppMetadata, TachographDriverStatus } from '@quadminds/shared/tracking-system';
import { DeviceStatus } from '../../enums';

export interface IDevicePositionSchema {
    id?: number;
    deviceId: number;
    latitude: string;
    longitude: string;
    organizationId: string;
    licensePlate: string;
    reportedDate: string;
    on?: boolean | null;
    speed?: number | null;
    status?: DeviceStatus;
    heading?: number | null;
    vehicleCode?: string | null;
    vehicleName?: string;
    trip?: Trip;
    deviceExternalId: string;
    isSemitrailer?: boolean;
    tags?: string[];
    identifier?: {
        type: string;
        value: string;
        driverName?: string;
    };
    tachograph?: {
        currentStatus: TachographDriverStatus;
        driverId?: string;
        driverFullName?: string;
    };
    metadata?: MobileAppMetadata;
}

interface Trip {
    id?: string;
    code?: string;
}

export interface DevicePositionByPolygon {
    licensePlate: string;
    tripCode: string;
    maxSpeed: number;
    routePath: string[];
}
